import React from 'react'
import { Button, LinkInline } from '@dasa-health/alma-react'
import { Typography } from '@dasa-health/components-react'
import { GenericCollapse } from './../GenericCollapse'
import { ButtonBox, CollapseContainer, Container } from './styles'
import { useAppContext } from '@nsw-paginas-deslogadas/store'
import { BrandMapping } from '@nsw-paginas-deslogadas/assets'

type Question = {
    title: string
    text: string
}

interface FoldFaqProps {
    // category?: number
    examLink?: string
    questions?: Question[]
    vaccineActive?: boolean
    vaccineLink?: string
}

const FoldFaq: React.FC<FoldFaqProps> = ({ questions, vaccineLink, examLink, vaccineActive = false }) => {
    const { brand, product } = useAppContext()
    const map = BrandMapping[brand.mappingId]

    const dataAtributtes = (dataText: string) => ({
        'data-item-position': 'FAQ',
        'data-current-service': 'Página da Marca',
        'data-item-text': dataText,
    })

    return (
        <Container data-testid="faq-testID">
            <h2>Dúvidas frequentes</h2>
            <CollapseContainer>
                {questions?.map((item, index) => (
                    <GenericCollapse isOpen={index === 0} key={index} renderLPV2={map.renderLPV2} showDivider title={item.title}>
                        <Typography>{item.text}</Typography>
                    </GenericCollapse>
                ))}
            </CollapseContainer>
            <ButtonBox>
                {product?.category && (
                    <LinkInline href={product.navigateTo} sx={{ textDecoration: 'none' }} target="_self">
                        <Button data-testid="btn-exams">Agendar {product.category.id === 4 ? 'vacina' : 'exame'}</Button>
                    </LinkInline>
                )}

                {!product?.category && (
                    <>
                        {vaccineActive && (
                            <LinkInline
                                href={vaccineLink}
                                sx={{ textDecoration: 'none' }}
                                target="_self"
                                {...dataAtributtes('Agendar vacinas')}
                            >
                                <Button fullWidth variant="primary">
                                    Agendar vacina
                                </Button>
                            </LinkInline>
                        )}

                        <a href={examLink} target="_self" {...dataAtributtes('Agendar exames')}>
                            <Button fullWidth variant="primary">
                                Agendar exame
                            </Button>
                        </a>
                    </>
                )}
            </ButtonBox>
        </Container>
    )
}

export default FoldFaq
